import { render, staticRenderFns } from "./myQuote.vue?vue&type=template&id=491afb5a&scoped=true"
import script from "./myQuote.vue?vue&type=script&lang=js"
export * from "./myQuote.vue?vue&type=script&lang=js"
import style0 from "./myQuote.vue?vue&type=style&index=0&id=491afb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491afb5a",
  null
  
)

export default component.exports